import * as tslib_1 from "tslib";
import addInfoBarMessage from './addInfoBarMessage';
import prepareComposeViewStateForPopout from './prepareComposeViewStateForPopout';
import triggerPolicyTips from '../actions/triggerPolicyTips';
import { subscribeToRecipientsChangeEvent } from '../orchestrators/onRecipientsInComposeChange';
import { getStore } from '../store/composeStore';
import ComposeTarget from '../store/schema/ComposeTarget';
import ensureComposeTabHandler from '../utils/composeTabHandler';
import createComposeViewState from '../utils/createComposeViewState';
import createGroupComposeViewState from '../utils/createGroupComposeViewState';
import { getAllRecipientsAsEmailAddressStrings } from '../utils/getAllRecipientsAsEmailAddressStrings';
import getRecipientsCount from '../utils/getRecipientsCount';
import isEncryptionFeatureEnabled from '../utils/isEncryptionFeatureEnabled';
import startSession from 'owa-controls-findpeople-feedback-manager/lib/actions/startSession';
import { onComposeOpened } from 'owa-mail-actions/lib/composeActions';
import { openComposeActionName } from 'owa-mail-compose-action-names';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { addPopout, PopoutType } from 'owa-popout-store';
import getComplianceConfigurationOperation from 'owa-service/lib/operation/getComplianceConfigurationOperation';
import { lazyAddTab, TabType } from 'owa-tab-store';
import isTabViewEnabled from 'owa-tab-store/lib/utils/isTabViewEnabled';
import { action } from 'satcheljs/lib/legacy';
import { oneRecipientSelectedAction } from 'owa-readwrite-recipient-well';
var openComposeWithViewState = action('openComposeWithViewState')(function openComposeWithViewState(viewState, openTarget, popoutSource) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var state;
        return tslib_1.__generator(this, function (_a) {
            state = getStore();
            if (openTarget == ComposeTarget.PrimaryReadingPane && state.defaultViewState) {
                // There is still default compose before open a new one, we should not overwrite it.
                // Need to call trySaveAndCloseCompose() first.
                return [2 /*return*/];
            }
            if (openTarget == ComposeTarget.SecondaryTab ||
                (viewState.isInlineCompose && isTabViewEnabled())) {
                ensureComposeTabHandler();
                lazyAddTab.importAndExecute(TabType.Compose, !viewState.isInlineCompose /*isShown*/, !viewState.isInlineCompose /*makeActive*/, viewState);
            }
            else if (isMailFeatureEnabled('rp-popouts') && openTarget == ComposeTarget.Popout) {
                ensureComposeTabHandler();
                prepareComposeViewStateForPopout(viewState);
                addPopout(PopoutType.Compose, viewState, popoutSource);
            }
            else {
                state.defaultViewState = viewState;
            }
            if (viewState &&
                viewState.subjectPickerViewState.supportsSubjectPicker &&
                getRecipientsCount(viewState.toRecipientWell) === 1 &&
                getRecipientsCount(viewState.ccRecipientWell) === 0 &&
                getRecipientsCount(viewState.bccRecipientWell) === 0) {
                oneRecipientSelectedAction(viewState.toRecipientWell.recipients[0].persona);
            }
            if (isEncryptionFeatureEnabled()) {
                if (state.complianceConfigurations.size == 0) {
                    getComplianceConfigurationOperation().then(function (result) {
                        result.RmsTemplates.forEach(function (template) {
                            var rmsTemplate = {
                                TemplateDescription: template.Description,
                                TemplateName: template.Name,
                                RmsTemplateId: template.Id,
                            };
                            state.complianceConfigurations.set(template.Id, rmsTemplate);
                        });
                    });
                }
                if (viewState.operation == 4 /* EditDraft */) {
                    triggerPolicyTips(viewState, 32 /* OpenDraft */);
                }
            }
            subscribeToRecipientsChangeEvent(viewState);
            startSession(viewState.findPeopleFeedbackManager, getAllRecipientsAsEmailAddressStrings(viewState));
            return [2 /*return*/];
        });
    });
});
export { openComposeWithViewState };
export function prepareComposeViewState(initProps, groupId, attachmentFiles) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var viewState, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!groupId) return [3 /*break*/, 2];
                    return [4 /*yield*/, createGroupComposeViewState(tslib_1.__assign({ groupId: groupId }, initProps))];
                case 1:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, createComposeViewState(initProps)];
                case 3:
                    _a = _b.sent();
                    _b.label = 4;
                case 4:
                    viewState = _a;
                    if (isMailFeatureEnabled('rp-popouts') && attachmentFiles) {
                        viewState.attachmentFilesToUpload = attachmentFiles;
                    }
                    // Add "quoted body will be loaded" infobar if quoted body is not loaded for smart response in full compose
                    if (viewState.useSmartResponse &&
                        !viewState.isInlineCompose &&
                        !viewState.itemId &&
                        !viewState.quotedBody) {
                        addInfoBarMessage(viewState, 'warningNoQuotedBody');
                    }
                    return [2 /*return*/, viewState];
            }
        });
    });
}
export default action(openComposeActionName)(function openCompose(initProps, openTarget, groupId, attachmentFiles) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var viewState;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, prepareComposeViewState(initProps, groupId, attachmentFiles)];
                case 1:
                    viewState = _a.sent();
                    openComposeWithViewState(viewState, openTarget).then(function () {
                        // Raise onComposeOpened action
                        onComposeOpened();
                    });
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=openCompose.js.map